import React from "react";
import { useFieldArray } from "react-hook-form";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

function ExterraBaitStationCard({ register, index, onRemove }) {
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <TextField
              label="Bait Station #"
              {...register(`exterra_bait_stations.${index}.bait_station_no`)}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Location"
              {...register(`exterra_bait_stations.${index}.location`)}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Status"
              {...register(`exterra_bait_stations.${index}.status`)}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Action Taken"
              {...register(`exterra_bait_stations.${index}.action_taken`)}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>

        <Box textAlign="right" sx={{ mt: 2 }}>
          <IconButton color="error" size="small" onClick={onRemove} aria-label="Remove bait station">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
}

export default function ExterraCard({ control, register }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "exterra_bait_stations",
  });

  const canAdd = fields.length < 8;

  return (
    <Card variant="outlined">
      <CardHeader
        title="If Exterra Client"
        subheader="(up to 8 bait stations)"
        titleTypographyProps={{ variant: "h6", fontWeight: "bold" }}
      />
      <CardContent>
        {fields.map((f, idx) => (
          <ExterraBaitStationCard
            key={f.id}
            register={register}
            index={idx}
            onRemove={() => remove(idx)}
          />
        ))}

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            startIcon={<AddIcon />}
            disabled={!canAdd}
            onClick={() =>
              append({
                bait_station_no: "",
                location: "",
                status: "",
                action_taken: "",
              })
            }
            variant="outlined"
            size="small"
          >
            Add Bait Station
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
